import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/apiService";

export const GetAllPR_NotesTable = createAsyncThunk(
  "dropdowns/GetAllPR_NotesTable",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllPR_NotesTable"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const PR_NotesTableDropDown = createSlice({
  name: "PR_NotesTableDropDown",
  initialState: {
    PR_NotesTableDropDown: [],
    loadingPR_NotesTableDropDown: false,
    errorPR_NotesTableDropDown: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllPR_NotesTable.pending, (state, action) => {
        state.loadingPR_NotesTableDropDown = true;
        state.PR_NotesTableDropDown = action.payload;
        state.errorPR_NotesTableDropDown = null;
      })
      .addCase(GetAllPR_NotesTable.fulfilled, (state, action) => {
        state.loadingPR_NotesTableDropDown = false;
        state.PR_NotesTableDropDown = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllPR_NotesTable.rejected, (state, action) => {
        state.loadingPR_NotesTableDropDown = false;
        state.errorPR_NotesTableDropDown = action.payload;
      });
  },
});

export default PR_NotesTableDropDown.reducer;
